import { NavLink as RouterLink } from 'react-router-dom'
import { Box, Link, Typography } from '@mui/material'
import LogoSvg from './LogoSvg'
import { useTheme } from '@mui/material/styles'
import { useSelector } from 'react-redux'
import { PATH } from '../../../../routes/constant'
import { type IUserProfile } from '../../../../redux/api/types'

const Logo: React.FC = () => {
  const theme = useTheme()
  const mode = useSelector((state: any) => state.modeState)
  const user: IUserProfile = useSelector((state: any) => state.userState.user)
  return (
    <Box sx = {{ alignItems: 'center', display: 'flex' }}>
      <Link component={RouterLink}
        to={
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          `${mode.isWp === true ? `${process.env.REACT_APP_HOSTNAME}/` : PATH.HOME}`
        }
        sx = {{
          height: { xs: '40px', sm: '49px' },
          width: { xs: '40px', sm: '49px' }
        }}
      >
        <LogoSvg/>
      </Link>
      <Typography
        component="div"
        sx= {{
          color: theme.palette.grey[50],
          fontSize: { xs: '14px', sm: '18px' },
          fontWeight: 700,
          letterSpacing: 0.01,
          ml: '16px'
        }}
      >
        {user?.account.companyName}
      </Typography>
    </Box>
  )
}

export default Logo
